import confirmModal from './ConfirmModal';

export default confirmModal;
